import { useContext } from 'react';
import { Grid, TablePagination } from '@material-ui/core';
import { serialNumbersContext } from '../SerialNumbersProvider';
import BulkInsert from './BulkInsert';


let Toolbar = () => {
    let service = useContext(serialNumbersContext);


    return (
        <Grid container spacing={1} alignItems="center">
            <Grid item xs />

            <Grid item>
                <BulkInsert onClose={service.doSearch} />
            </Grid>

            <Grid item>
                <TablePagination
                    component="div"
                    count={service.recordCount}
                    onPageChange={(e, page) => service.changePage(page)}
                    page={service.search.pageNr}
                    nextIconButtonProps={{ size: 'small' }}
                    backIconButtonProps={{ size: 'small' }}
                    rowsPerPage={service.search.pageSize}
                    rowsPerPageOptions={[service.search.pageSize]}
                    labelDisplayedRows={({ page }) =>
                        <>
                            Total serial numbers:&nbsp;{service.recordCount} &nbsp;&middot;&nbsp;
                            <span>Page {page + 1} of {Math.ceil(service.recordCount / service.search.pageSize)}</span>
                        </>
                    }
                />
            </Grid>
        </Grid>
    )
}

export default Toolbar;